import { ILoginData } from '../types/loginData';

export const PRODUCT_DOMAIN = 'now.amagi.tv';

function getHostEnv():
  | 'dev'
  | 'test'
  | 'staging'
  | 'production'
  | 'automation' {
  const hostname = window.location.hostname;
  if (hostname.includes('dev.')) {
    return 'dev';
  }
  if (hostname.includes('staging.')) {
    return 'staging';
  }
  if (hostname.includes('test.')) {
    return 'test';
  }
  if (hostname.includes('automation.')) {
    return 'automation';
  }
  return 'production';
}

type Options =
  | { appType: 'sales' | 'ops' | 'platform' }
  | { appType: 'customer'; customerDomain: string };

function getSubDomain(options: Options): string {
  const env = getHostEnv();

  if (env === 'production') {
    if (options.appType === 'customer') {
      // earthtv.
      return options.customerDomain;
    }
    // sales.
    return options.appType;
  }

  // non prod env
  if (options.appType === 'customer') {
    // earthtv.dev. or earthtv.staging
    return options.customerDomain + '.' + env;
  }
  return options.appType + '.' + env;
}

function getDomain(options: Options) {
  const subDomain = getSubDomain(options);
  return 'https://' + subDomain + '.' + PRODUCT_DOMAIN;
}

export function getSignUpUrl(): string {
  const hostEnv = getHostEnv();
  if (hostEnv === 'production') {
    return `https://${PRODUCT_DOMAIN}/signup`;
  }
  return `https://${hostEnv}.${PRODUCT_DOMAIN}/signup`;
}

export function getOpsAppUrl(): string {
  return getDomain({ appType: 'ops' });
}

export function getPlatformAppUrl(): string {
  return getDomain({ appType: 'platform' });
}

export function getSalesAppUrl(): string {
  return getDomain({ appType: 'sales' });
}

export function getCustomerAppUrl(customerDomain: string): string {
  return getDomain({ appType: 'customer', customerDomain });
}

export function getSignInUrl(): string {
  const hostEnv = getHostEnv();
  if (hostEnv === 'production') {
    return `https://${PRODUCT_DOMAIN}/signin`;
  }
  return `https://${hostEnv}.${PRODUCT_DOMAIN}/signin`;
}

export function getSignedInAppUrl(loginData: ILoginData): string {
  if (loginData.role === 'amagi_sales_admin') {
    return getSalesAppUrl();
  }
  if (loginData.role === 'amagi_operator_admin') {
    return getOpsAppUrl();
  }
  if (loginData.role === 'amagi_platform_admin') {
    return getPlatformAppUrl();
  }
  return getCustomerAppUrl(loginData.account_domain);
}

export function gotoSignedInApp(loginData: ILoginData): void {
  const appUrl = getSignedInAppUrl(loginData);
  window.location.assign(appUrl);
}

export function gotoSignInPage(): void {
  const signInUrl = getSignInUrl();
  window.location.assign(signInUrl);
}

export function handleHomePageNavigation(): void {
  const env = getHostEnv();
  if (env === 'production') {
    window.location.assign(`https://${PRODUCT_DOMAIN}/signup`);
    return;
  }
  window.location.assign(`https://${env}.${PRODUCT_DOMAIN}/signup`);
}

export function goToForgotPasswordScreen() {
  const env = getHostEnv();
  if (env === 'production') {
    window.location.assign(
      `https://accounts.${PRODUCT_DOMAIN}/forgot-password`,
    );
    return;
  }
  window.location.assign(
    `https://accounts.${env}.${PRODUCT_DOMAIN}/forgot-password`,
  );
}
